import {
  VisitTrackingService,
  AnalyticsService,
} from '../services/url-shortener';
import type {
  http_VisitStatsResponse,
  http_VisitResponse,
  http_BatchStatsRequest,
  http_BatchStatsItem,
  http_UniqueCountriesResponse,
} from '../services/url-shortener';

export type VisitStatsResponse = http_VisitStatsResponse;
export type VisitResponse = http_VisitResponse;
export type BatchStatsRequest = http_BatchStatsRequest;
export type BatchStatsItem = http_BatchStatsItem;

export type BatchStatsResponse = {
  stats?: Array<http_BatchStatsItem>;
  success?: boolean;
};

export type CountriesResponse = http_UniqueCountriesResponse;

export const getVisitStats = (shortId: string): Promise<VisitStatsResponse> => {
  return VisitTrackingService.getVisitsStats(shortId);
};

export const getVisits = (
  shortId: string,
  excludeCountries?: string[]
): Promise<VisitResponse> => {
  const excludeCountriesParam =
    excludeCountries && excludeCountries.length > 0
      ? excludeCountries.join(',')
      : undefined;

  return VisitTrackingService.getVisits(shortId, excludeCountriesParam);
};

export const getBatchVisitStats = (
  shortIds: string[],
  excludeCountries?: string[]
): Promise<BatchStatsResponse> => {
  return AnalyticsService.postAnalyticsVisitsStats({
    short_ids: shortIds,
    ...(excludeCountries && excludeCountries.length > 0
      ? { exclude_countries: excludeCountries }
      : {}),
  });
};

export const getAnalyticsCountries = (): Promise<CountriesResponse> => {
  return AnalyticsService.getAnalyticsCountries();
};
